export const MAP_STATE_KEY = "MAP_STATE";
